import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { HeaderActions, type HeaderAction } from './HeaderActions';

// Shared header row for the Note, Task and View detail pages (#269): a back
// link and an optional "All X" link on the left, then HeaderActions. Like
// MeetingHeader it is a CSS container, so it steps down by its own width:
// the back link truncates, and "All X" hides under 640px.

interface Props {
  back: { to: string; label: string };
  /** e.g. "All Notes", shown when the back link goes somewhere else. */
  all?: { to: string; label: string };
  lastSaved?: string | null;
  saving?: boolean;
  always?: ReactNode;
  actions: HeaderAction[];
}

export function DetailHeader({ back, all, lastSaved, saving, always, actions }: Props) {
  return (
    <div className="@container mb-4 no-print" data-testid="detail-header">
      <div className="flex items-center gap-3 min-w-0">
        <Link
          to={back.to}
          title={back.label}
          className="flex items-center gap-1 min-w-0 text-sm text-text-muted hover:text-text-primary transition-colors"
        >
          <ChevronLeft size={16} className="flex-shrink-0" />
          <span className="truncate">{back.label}</span>
        </Link>
        {all && (
          <Link
            to={all.to}
            className="flex-shrink-0 whitespace-nowrap text-xs text-text-muted hover:text-text-secondary transition-colors @max-[640px]:hidden"
          >
            {all.label}
          </Link>
        )}
        <div className="ml-auto flex-shrink-0">
          <HeaderActions lastSaved={lastSaved} saving={saving} always={always} actions={actions} />
        </div>
      </div>
    </div>
  );
}
